export class Size {
  public static COMPOUND_NODE_LABEL_SIZE: number = 14;
}
